var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',[_vm._v("© 2018 "),_c('a',{attrs:{"href":"http://www.unilab.eu/"}},[_vm._v("Unilab")])])])
}]

export { render, staticRenderFns }